<template>
  <tr>
    <td data-cy="employee-name">{{ reportRow.subordinate.full_name }}</td>
    <td>{{ reportRow.subordinate.code }}</td>
    <td data-cy="approver-name">{{ reportRow.approver.full_name }}</td>
    <td>{{ reportRow.approver.code }}</td>
    <td data-cy="source-type">
      <button
        v-if="activeEmployment.is_admin"
        class="btn btn-link tw-p-0"
        type="button"
        @click.prevent="changeApproverSettings"
      >
        {{ source }}
      </button>
      <span v-else>{{ source }}</span>
    </td>
  </tr>
</template>

<script>
export default {
  name: 'ApproverReportTableRow',

  props: {
    reportRow: {
      type: Object,
      required: true,
    },
  },

  computed: {
    source() {
      if (this.reportRow.source === 'Department') {
        return `${this.reportRow.source} - ${this.reportRow.subordinate.department_name}`
      }

      return this.reportRow.source
    },
  },
  methods: {
    async changeApproverSettings() {
      const navigateTo =
        this.reportRow.source === 'Department'
          ? `/settings/departments?company=${this.activeCompany.id}&department_id=${this.reportRow.subordinate.department_id}`
          : `/settings/employees?company=${this.activeCompany.id}&employment_id=${this.reportRow.subordinate.id}`

      window.location = navigateTo
    },
  },
}
</script>
